import { Flex, Text } from '@chakra-ui/react';
import { Icon2Cars } from 'icons';

const GridCounter = ({ participants }: { participants: number }) => {
  return (
    <Flex
      gap="2"
      alignItems="center"
    >
      <Text
        fontSize={{ base: '12px', md: '14px' }}
        lineHeight={{ base: '16px', md: '18px' }}
        fontWeight="500"
        color="cerebralGrey.100"
      >
        GRID
      </Text>

      <Flex
        background="linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)"
        borderRadius="4px"
        alignItems="center"
        p="1px 4px"
        gap="1"
      >
        <Icon2Cars
          __css={{
            path: {
              fill: 'white.100'
            }
          }}
          boxSize={{ base: '4', md: '5' }}
        />
        <Text
          fontSize={{ base: '12px', md: '14px' }}
          lineHeight={{ base: '16px', md: '18px' }}
          fontWeight="500"
          color="white.80"
          fontStyle="italic"
        >
          {participants} / 20
        </Text>
      </Flex>
    </Flex>
  )
};

export default GridCounter;
